{
  "pipes": {
    "appointment_status": {
      "BLOCKER": "Bloqueur",
      "CONFIRMED": "Confirmé",
      "CHECKED_IN": "Checked in",
      "FULFILLED": "Checked out",
      "BO_CANCELLED": "Salon annulé",
      "CUSTOMER_CANCELLED": "Client annulé",
      "EXPIRED": "Expired",
      "OTHER": "Autres"
    },
    "booking_type": {
      "BLOCKER": "Bloqueur",
      "AGENT": "Agent IA",
      "TELEPHONE": "Téléphone",
      "ONLINE": "Internet",
      "TREATWELL": "Treatwell",
      "RWG": "Google"
    },
    "communication_way": {
      "EMAIL": "Email",
      "SMS": "SMS",
      "no_matter": "Peu importe"
    },
    "customer_type": {
      "vip": "VIP",
      "new": "Nouveau client",
      "regular": "Client régulier",
      "at_risk": "Client à risque",
      "normal": "Client normal"
    },
    "language": {
      "cs-CZ": "Tchèque",
      "de-DE": "Allemand",
      "fr-FR": "Français",
      "en-US": "Anglais",
      "vi-VN": "Vietnamien"
    },
    "month": [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre"
    ],
    "notification_type": {
      "NEW_APPOINTMENT": "Nouvelle nomination",
      "APPOINTMENT_CANCELLED": "Rendez-vous annulé par le client",
      "APPOINTMENT_MESSAGE": "Nouveau message",
      "BO_UPDATED": "Rendez-vous mis à jour par le salon",
      "BO_CANCELLED": "Rendez-vous annulé par le salon"
    },
    "weekday": {
      "MONDAY": "Lundi",
      "TUESDAY": "Mardi",
      "WEDNESDAY": "Mercredi",
      "THURSDAY": "Jeudi",
      "FRIDAY": "Vendredi",
      "SATURDAY": "Samedi",
      "SUNDAY": "Dimanche"
    },
    "weekday_short": {
      "MONDAY": "Lu.",
      "TUESDAY": "Ma.",
      "WEDNESDAY": "Me.",
      "THURSDAY": "Je.",
      "FRIDAY": "Ve.",
      "SATURDAY": "Sa.",
      "SUNDAY": "Di."
    },
    "review_type": {
      "all": "Tous les commentaires",
      "internal_only": "Examens internes uniquement",
      "google_only": "Avis de Google uniquement"
    },
    "time": {
      "day": "jour",
      "days": "jours",
      "hour": "heure",
      "hours": "heures",
      "minute": "minute",
      "minutes": "minutes",
      "month": "mois",
      "months": "mois",
      "now": "maintenant",
      "second": "deuxième",
      "seconds": "secondes",
      "year": "année",
      "years": "années",
      "timestamp_in_future": "en {{time}}",
      "timestamp_in_the_past": "Il y a {{time}}",
      "today": "aujourd'hui"
    },
    "time_period": {
      "all": "Tous",
      "today": "Aujourd'hui",
      "yesterday": "Hier",
      "this_week": "Cette semaine",
      "this_month": "Ce mois-ci",
      "last_month": "Le mois dernier",
      "this_quarter": "Ce trimestre",
      "last_quarter": "Dernier trimestre",
      "this_year": "Cette année",
      "last_year": "L'année dernière"
    },
    "text": {
      "deleted-service": "Service supprimé",
      "deleted-staff": "Personnel supprimé",
      "deleted-staff-passive": "Personnel supprimé",
      "first-available-staff": "Premier personnel disponible",
      "first-available-staff-passive": "Premier personnel disponible",
      "other": "autres",
      "others": "autres",
      "to": "to",
      "walk_in_customer": "Clientèle de passage"
    }
  }
}
